module.exports = require('./isObjectLike')
